import { useParams } from "react-router-dom";
import { useStandardQuery } from "../../../../../hooks";
import Page from "../../../../../Components/Layout/Page";
import { AppBarTitle } from "../../../../../layout/appbar/Title/context";
import { IDocument } from "../../../../../models/document";
import AddDocument from "./Components/AddDocument";
import DocumentsList from "./Components/DocumentsList";

export default function Documents({
  isInternal = false
}: {
  isInternal?: boolean
}) {

  const params = useParams();
  const { savId } = params;

  // ✅ Conforme CONETEXT.md
  const { data, refetch } = useStandardQuery<IDocument[]>(
    ['sav-documents', savId],
    '/sav/' + savId + '/documents',
    {}
  );
  const { data: dataInternal, refetch: refetchInternal } = useStandardQuery<IDocument[]>(
    ['sav-documents', savId, 'internal'],
    '/sav/' + savId + '/documents',
    {
      params: {
        internal: true
    }
  });

  if (!savId) return <div>Missing savId</div>;

  return (
    <Page>

      <AppBarTitle title={`Documents ${!isInternal ? 'partagés avec le bénéficiaire' : 'internes'}`} append />

      <AddDocument
        title={`Ajouter un document ${!isInternal ? 'partagé avec le bénéficiaire' : 'interne'}`}
        isInternal={isInternal}
        savId={parseInt(savId)}
        refetch={async () => {
          await refetch();
          await refetchInternal();
        }}
      />

      {!isInternal && (
      <DocumentsList
        title="Documents partagés avec le bénéficiaire"
        data={data || []}
      />
      )}

      {isInternal && (
      <DocumentsList
        title="Documents internes"
        data={dataInternal || []}
      />
      )}
    </Page>
  )
}